const TOKEN_COOKIE_NAME = 'xc-match-2026_token'

const getCookie = (name) => {
  if (typeof document === 'undefined') {
    return ''
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }

  return ''
}

export const resolveInitialToken = (route) => {
  return getCookie(TOKEN_COOKIE_NAME) || route.query?.token || ''
}
